const DeleteCardModal = ({ open, onClose, onDelete, isDeletingCard }) => {
  return (
    <>
      {open && (
        <>
          <div className="fixed px-5 md:px-0 inset-0 z-50 flex items-center justify-center bg-black/40">
            <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 relative animate-fade-in">
              {/* Close Button */}
              <button
                onClick={onClose}
                className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 focus:outline-none"
                aria-label="Close modal"
              >
                <svg
                  width="24"
                  height="24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  viewBox="0 0 24 24"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
              {/* Icon */}
              <div className="flex items-center justify-center mb-6">
                <div className="bg-gradient-to-br from-[#f7f8fa] to-[#e8eaf0] rounded-full p-4 flex items-center justify-center">
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#2d348f"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="2" y="5" width="20" height="14" rx="2" />
                    <line x1="2" y1="10" x2="22" y2="10" />
                    <path
                      d="M15.5 15.5L8.5 8.5"
                      stroke="#e53e3e"
                      strokeWidth="2"
                    />
                    <path
                      d="M8.5 15.5L15.5 8.5"
                      stroke="#e53e3e"
                      strokeWidth="2"
                    />
                  </svg>
                </div>
              </div>
              <h2 className="text-xl md:text-2xl font-extrabold text-[#2d348f] mb-3 text-center">
                Delete Card & Cancel Subscription
              </h2>
              <p className="text-[#837f90] text-base mb-4 text-center">
                If you delete your card, your subscription will be automatically
                set to cancel, but you will still have access to the app until
                the end of the current billing period.
              </p>
              <p className="text-[#837f90] text-base mb-6 text-center">
                Are you sure you want to continue?
              </p>
              {/* Footer Buttons */}
              <div className="flex justify-center gap-4 mt-6">
                <button
                  onClick={onClose}
                  disabled={isDeletingCard}
                  className="px-6 py-2 rounded-lg font-semibold bg-[#f7f8fa] text-[#2d348f] border border-[#2d348f] hover:bg-[#e8eaf0] transition"
                >
                  Cancel
                </button>
                <button
                  onClick={onDelete}
                  className="px-6 py-2 rounded-lg font-semibold bg-[#2d348f] text-white hover:bg-[#1a1f6b] transition"
                  disabled={isDeletingCard}
                >
                  {isDeletingCard ? "Deleting..." : "Continue"}
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default DeleteCardModal;
